import { createApp } from 'vue';
export function createVue3AppPackage(appComponent, setup) {
    return new class LayoutApp {
        async create(elOrConfig, configParam) {
            const config = typeof configParam !== 'undefined' ? configParam : elOrConfig;
            let el = typeof configParam !== 'undefined' ? elOrConfig : undefined;
            if (!el && typeof elOrConfig === 'object') {
                el = elOrConfig.el;
            }
            const comp = await appComponent();
            const instance = await setup(createApp(comp, config));
            const packageInstance = {
                config,
                instance,
                mount(el) {
                    this.componentInstance = this.instance.mount(el);
                    return Promise.resolve();
                },
                unmount() {
                    this.instance.unmount();
                    return Promise.resolve();
                },
                update(config) {
                    Object.assign(this.config, config);
                    if (this.componentInstance) {
                        this.componentInstance.$forceUpdate();
                    }
                    return Promise.resolve();
                }
            };
            if (el) {
                await packageInstance.mount(el);
            }
            return packageInstance;
        }
    };
}
